module.exports = __webpack_public_path__ + "img/home_1_2.3992b038.png";